export default "__VITE_ASSET__BVclo4zk__"